export default __webpack_public_path__ + "static/media/gallery-img04.f6e1d5e8.jpg";